import Vue from "vue";
import App from "./App.vue";
import UnsupportedBrowserBanner from "./UnsupportedBrowserBanner.vue";
import router from "./router";
import Vuelidate from "vuelidate";
import { VueMaskDirective } from "v-mask";
import store from "./store/store";
import HotJar from "vue-hotjar";
import logger from "@/utils/logger";
import browserHelper from "@/utils/browser-helper";
import vuetify from "@/plugins/vuetify";
import "@fontsource/poppins";
import flagsmith from "flagsmith";

const hotJarEnabledEnvs = ["prod", "test"];
let isHotJarEnabled = hotJarEnabledEnvs.indexOf(process.env.VUE_APP_ENVIRONMENT) >= 0;

logger.init();
logger.info("NPE loaded");

if (isHotJarEnabled) {
  Vue.use(HotJar, {
    id: process.env.VUE_APP_HOTJAR_ID,
    isProduction: isHotJarEnabled,
  });
}

Vue.use(Vuelidate);
Vue.use(vuetify);
Vue.directive("mask", VueMaskDirective);

Vue.config.productionTip = process.env.VUE_APP_IS_PRODUCTION;

flagsmith.init({
  environmentID: process.env.VUE_APP_FLAGSMITH_ENVIRONMENT_ID,
  cacheFlags: process.env.VUE_APP_FLAGSMITH_CACHE,
  cacheOptions: {
    ttl: 1800000,
  },
});

export default (selector) => {
  if (browserHelper.isIe()) {
    new Vue({
      render: (h) => h(UnsupportedBrowserBanner),
    }).$mount(selector);
  } else {
    new Vue({
      vuetify,
      router,
      store,
      render: (h) => h(App),
    }).$mount(selector);
  }
};
